<template>
  <v-card width="100%">
    <div class="barometer-wrapper">
      <div class="barometer-header">
        <h2>Stylingproducten verkocht</h2>
        <!-- <h2>Product ID: {{employeeName}} {{employeeID}}</h2> -->
        <h3>
          <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span>
        </h3>
      </div>
      <div class="barometer-canvas-wrapper">
        <canvas
          :id="canvasID"
          generateGradient="true"
          width="220"
          height="130"
        ></canvas>
      </div>
      <div class="barometer-footer">
        <p class="barometer-rate ma-0">
          <span v-if="actualPercentage > 100" class="on-fire"></span>
          {{ actualPercentage }}
          <span v-if="actualPercentage == 1">product</span>
          <span v-else>producten</span>
        </p>
        <!-- <p
        v-if="producttarget"
        class="barometer-description"
      >Persoonlijk product doel = {{producttarget.toFixed(0)}} <span v-if="producttarget == 1">product</span>
        <span v-else>producten</span></p>
      <div v-else class="barometer-alert">
        <v-alert :value="true" type="warning">Er is nog geen doel ingesteld.</v-alert>
      </div> -->
      </div>
    </div>
  </v-card>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../../firebase/init";
import { bus } from "../../main";
import { log } from "util";
export default {
  props: [
    "level",
    "marks",
    "aperture",
    "colorStop",
    "colorStart",
    "canvasID",
    "rate",
    "weeknr",
    "selectedDataView",
    "compDataView",
    "selectedDataWeek",
    "selectedDataMonths",
    "selectedDataFourWeeks",
    "selectedDataYear",
    "months",
  ],
  name: "customProductData",
  data: () => ({
    mini: true,
    id: null, //passed getal door
    canvasRender: null,
    actualPercentage: null, //Status Barometer employee
    producttarget: null,
    opts: {
      angle: -0.1, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676",
      },
      colorStop: "#333",
      colorStart: "#333",
      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      // generateGradient: true,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      },
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    },
  }),

  created() {
    bus.$on("employeeBarometerUpdate", this.updateData);
    if (this.colorStop && this.colorStart) {
      this.opts.colorStop = this.colorStop;
      this.opts.colorStart = this.colorStart;
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      this.actualPercentage = this.rate.count;

      // console.log("Update data getriggerd: " + this.employeeName + " " + this.actualPercentage);

      // var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(this.opts); // Unieke Gauge opbouwn
      gauge.maxValue = this.actualPercentage + 10; // max gauge value
      gauge.setMinValue(0); // min value
      gauge.set(this.actualPercentage); // actual valu0;
    },
  },

  computed: {
    // intel() {
    //   if (this.revenue == null) {
    //     return `<span style="">Er is nog geen doel voor deze medewerker ingesteld.</span>`;
    //     // return `<span style="">Er is nog geen doel voor ${this.employeeName} ingesteld.</span>`;
    //   } else {
    //     return `<span style="red">De doelstelling is om boven de 100% te blijven.</span>`;
    //     // return `<span style="red">De doelstelling voor ${this.employeeName} is rond de 100% te blijven.</span>`;
    //   }
    // }
  },
};
</script>
